import React, { useState, useEffect } from "react";
import List from "../../styledComponents/Table/List";
import DEATH_API from "../../../apis/death.api";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import swal from "sweetalert";
import SearchIcon from "../../../assets/images/DeathModuleNew/Search.png";
import "./revertDeletion.css";

const RevertDeletionMain = () => {
  const [loading, setLoading] = useState(false);
  const [requests, setRequests] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const fetchRequests = async () => {
    try {
      setLoading(true);
      const res = await DEATH_API.fetchDeleteUserAccountList();
      if (res && res.data) {
        setRequests(res.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching deletion requests:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  const handleRevert = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Do you want to revert this account deletion request?",
      icon: "warning",
      buttons: ["No, cancel it!", "Yes, revert it!"],
      dangerMode: true,
    }).then(async (willRevert) => {
      if (willRevert) {
        try {
          setLoading(true);
          const res = await DEATH_API.revertAccountDeletion(id);
          setLoading(false);
          if (res && res.status === 200) {
            swal(
              "Success",
              "Account deletion request reverted successfully",
              "success",
            );
            fetchRequests();
          } else {
            swal("Error", res.message || "Failed to revert request", "error");
          }
        } catch (error) {
          console.error("Error reverting deletion request:", error);
          setLoading(false);
          swal("Error", "Something went wrong", "error");
        }
      }
    });
  };

  const handleSearch = (event) => {
    const term = event.target.value.toLowerCase();
    setSearchTerm(term);
    const filtered = requests.filter(
      (item) =>
        (item.user &&
          item.user.name &&
          item.user.name.toLowerCase().includes(term)) ||
        (item.user &&
          item.user.email &&
          item.user.email.toLowerCase().includes(term)) ||
        (item.id && item.id.toString().includes(term)),
    );
    setFilteredData(filtered);
  };

  const columns = [
    {
      title: "Request ID",
      dataIndex: "id",
      key: "id",
      render: (text) => text || "N/A",
    },
    {
      title: "User ID",
      dataIndex: ["user", "id"],
      key: "userId",
      render: (text) => text || "N/A",
    },
    {
      title: "Name",
      dataIndex: ["user", "name"],
      key: "name",
      render: (text) => text || "N/A",
    },
    {
      title: "Email",
      dataIndex: ["user", "email"],
      key: "email",
      render: (text) => text || "N/A",
    },
    {
      title: "Request Date",
      dataIndex: "soft_delete",
      key: "soft_delete",
      render: (text) => (text ? new Date(text).toLocaleDateString() : "N/A"),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <button className="revert-btn" onClick={() => handleRevert(record.id)}>
          Revert Deletion
        </button>
      ),
    },
  ];

  return (
    <div className="revert-deletion-container">
      <div className="revert-deletion-card">
        <div className="card-header" style={{background:"#ffffff"}}>
          <h2 className="card-title" style={{fontSize:"16px"}}>Account Deletion Requests</h2>
          <div className="search-wrapper">
            <div className="search-input-container">
              <img src={SearchIcon} alt="search" className="search-icon" />
              <input
                type="text"
                placeholder="Search by name or email"
                value={searchTerm}
                onChange={handleSearch}
                className="search-input"
                style={{marginBottom: "0px"}}
              />
            </div>
          </div>
        </div>
        <div className="table-wrapper">
          <List cols={columns} rows={searchTerm ? filteredData : requests} />
        </div>
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};

export default RevertDeletionMain;
